import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ListService } from '../../ajs-upgraded-providers';
import { FileUtilsService } from '../../rl-common/file/core/file-utils.service';
import { ApiService } from '../../rl-common/shared/shared/interfaces/api-service';
import { List } from '../../store/model/list.model';
import { Section } from '../../store/model/section.model';
import { ListQueryParams } from '../shared/list-query-params';

@Injectable({
  providedIn: 'root'
})
export class ngListService implements ApiService<List>{

  currentList : List;
  allLists : List[] = [];

  constructor(private http : HttpClient, private listServiceAjs : ListService, private fileUtils : FileUtilsService) { }

  getAll = (params?: ListQueryParams) : Observable<List[]> => new Observable<List[]>(s => {
    if(params.courses) params.courses = params.courses.join();
    this.http.get(`../rl/main/lists`, {params : params}).subscribe((res : any) =>{
      s.next(res.object.lists);
      this.allLists.concat(res.object.lists);
    });
  });

  get = (id?: string) : Observable<List> =>  new Observable<List>(s =>{
    this.http.get<List>(`../rl/main/lists/${id}`).subscribe((l : any)=> {
      this.currentList = l.object;
      s.next(l.object);
    });
  });

  create: (entity: List) => Observable<List>;

  save: (entity: List) => Observable<List>;

  delete: (entity: List) => Observable<void>;

  getList = (listId : number | string) : List => this.listServiceAjs.getListById(listId);

  getCitationsWithFile(listId : number | string, fileSuffix? : string){
    let citations = [];

    (listId ? this.getList(listId) : this.currentList)
    .sections?.forEach(s => s.citations?.filter(c => c.amazonFileKey && (!fileSuffix || this.fileUtils.getFileExtension(c.amazonDisplayFileName) == fileSuffix)).forEach(c => citations.push({key : c.id, value : c.dc.title})));

    return citations;
  }

  getCitationsWithPDF = (listId : number | string) => this.getCitationsWithFile(listId, "pdf");

  isThereCitationsWithFile = (listId? : number | string, fileSuffix? : string) => (listId ? this.getList(listId) : this.currentList).sections?.some(s => s.citations?.some(c => c.amazonFileKey && (!fileSuffix || this.fileUtils.getFileExtension(c.amazonDisplayFileName) == fileSuffix)));

  isThereCitationsWithPDF = (listId? : number | string) => this.isThereCitationsWithFile(listId, "pdf");

  getSections(sectionsType : 'CITATION' | 'ASSIGNMENT', listId? : number | string) : Section[]{
    let list = (listId ? this.getList(listId) : this.currentList);

    switch(sectionsType){
      case 'CITATION' : return list.sectionsCitation;
      case 'ASSIGNMENT' : return list.sectionsAssignment;
    }
  }
}
